module.exports = __webpack_public_path__ + "static/media/darksky.7021f77c.png";